import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

import { AppEnv, ROOT_HOST } from '../../../../config/appEnv';
import config from '../../../../config/config';
import { checkIfWindowPropertyIsLoaded } from '../../../../utils/checkIfWindowPropertyIsLoaded';
import { OptanonCustomGroupId } from '../../../../utils/CookiePermissions';

export const GeniallyLogrocketAppId = 'genially-z2e5p/genially';
export const GeniallyLogrocketViewAppId = 'genially-z2e5p/view-em2xk';
export const GeniallyLogrocketPlayAppId = 'genially-z2e5p/play-ioyop';

interface LogRocketArgs {
  releaseVersion: string;
  appId: string;
  parentDomain?: string;
  childDomains?: string[];
}

const deleteUndefinedProps = (obj: object) => {
  Object.keys(obj).forEach(key =>
    key in obj && obj[key as keyof typeof obj] === undefined
      ? // eslint-disable-next-line no-param-reassign
        delete obj[key as keyof typeof obj]
      : {},
  );
};

function loadLogRocket({
  releaseVersion,
  appId,
  parentDomain,
  childDomains,
}: LogRocketArgs) {
  const logRocketArgs = {
    release: releaseVersion,
    mergeIframes: true,
    childDomains,
    parentDomain,
    rootHostname: ROOT_HOST,
    network: {
      isEnabled: false,
    },
  };

  deleteUndefinedProps(logRocketArgs);

  LogRocket.init(appId, logRocketArgs);
  setupLogRocketReact(LogRocket);
}

const onConsentChanged = (): Promise<string[]> => {
  return new Promise(resolve => {
    window.Optanon?.OnConsentChanged(e => {
      resolve(e.detail);
    });
  });
};

export const hasOnetrustPermissionToLoadLogRocket = (): boolean => {
  return window.OnetrustActiveGroups?.includes(OptanonCustomGroupId.Performance) === true;
};

export const loadLogRocketIntegration = async (
  args: LogRocketArgs,
  ignoreOptAnon = false,
): Promise<boolean> => {
  if (config.appEnv !== AppEnv.Local && config.appEnv !== AppEnv.Dynamic) {
    if (ignoreOptAnon) {
      loadLogRocket(args);

      return true;
    }

    const optanonIsLoaded = await checkIfWindowPropertyIsLoaded('Optanon');

    if (optanonIsLoaded && window.Optanon) {
      if (hasOnetrustPermissionToLoadLogRocket()) {
        loadLogRocket(args);

        return true;
      }

      const newConsent = await onConsentChanged();

      if (newConsent.includes(OptanonCustomGroupId.Performance)) {
        loadLogRocket(args);

        return true;
      }
    }
  }

  return false;
};
